<script lang="ts">
	import { classes } from '@thearc-hq/ui-kit/utils';
	import Button from './Button.svelte';
	import { getTranslate } from '@tolgee/svelte';

	export let additionalClass: string = '';

	const { t } = getTranslate();
</script>

<Button
	class={classes(
		additionalClass,
		'px-4 !rounded hover:underline text-accent-primary text-h-12 uppercase'
	)}
	on:click={() =>
		window.open(
			'https://shop-sprenger.returnsportal.online/v3',
			// TODO pre-populate order number and email address
			// ?order_name=${
			//                     orderNumber ?? ''
			//                   }&email=${customer?.email ?? ''}`,
			'blank'
		)}
	text={$t('orders.item.sendBack')}
	iconPosition="right"
>
	<div class="i-sprenger-package w-4 h-4" slot="icon" />
</Button>
